import $ from 'jquery';

// VARS
// range slider
let slider = document.getElementById( 'rangeSlider' );

// main slider output
let output = document.getElementById( 'rangeOut' );

//slider output range
let $low = document.getElementById( 'rangeOutLower' );
let $high = document.getElementById( 'rangeOutHigher' );

// min/max of available pricepoints
let $sliderLow = document.getElementById( 'sliderLow' );
let $sliderHigh = document.getElementById( 'sliderHigh' );


// makes a value convert from 400,000 to 400k or 1,600,000 to 1.6m
function numFormatter( num ) {
  return Math.abs( num ) > 999 && Math.abs( num ) < 1000000 ? Math.sign( num )*( ( Math.abs( num )/1000 ).toFixed( 1 ) ) + 'k' : Math.sign( num )*( ( Math.abs( num )/1000000 ).toFixed( 1 ) ) + 'mil'
}

function renderShowhomeGrid(){
  //determines length of showhomes cards. and applys full width placeholder if 0
  $( '.js-builder' ).each( function() {
    const showhomes = $( this ).find('.js-showhomeCard:not(.hidden)');

    if( showhomes.length == 0 ){
      $( this ).find('.js-fullWidth').show();
    } else {
      $( this ).find('.js-fullWidth').hide();
    }
  })
}

// replace with commas
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// On document load || this is the starting data for our slider
$( () => {
  // Display the default slider value
  output.innerHTML = numberWithCommas( parseInt( slider.value ) );

  // Display the default slider value - 50000
  $low.innerHTML = numFormatter( parseInt(slider.value) - 50000 );

  // Display the default slider value + 50000
  $high.innerHTML = numFormatter( parseInt( slider.value ) + 50000 );

  $sliderLow.innerHTML = numFormatter( $(slider).attr('min') );
  $sliderHigh.innerHTML = numFormatter( $(slider).attr('max') );

  // Update the current slider value ( when you lift off slider )
  slider.onchange = sliderChanged;
})

// massive breakout on slider options for conversion tracking
const sliderChanged = () => {
  // Display the default slider value
  output.innerHTML = numberWithCommas( parseInt( slider.value ) );

  const $sliderInput = parseInt( slider.value )
  let low = 1;
  let high = 999999999999;

  // if a value is less than a an amount subtract a certain amount, then remove 3 zeros with numFormatter
  if( $low.innerHTML =  $sliderInput < 410000 ){
    low = $sliderInput - 25000;

  } else if( $low.innerHTML =  $sliderInput < 610000 ){
    low = $sliderInput - 50000;

  } else if( $low.innerHTML =  $sliderInput < 810000 ){
    low = $sliderInput - 75000;

  } else if( $low.innerHTML =  $sliderInput < 1010000 ){
    low = $sliderInput - 100000;

  } else if( $low.innerHTML =  $sliderInput < 1610000 ){
    low = $sliderInput - 150000;
  };

  if( $high.innerHTML =  $sliderInput < 410000 ){
    high = $sliderInput + 25000;

  } else if( $high.innerHTML =  $sliderInput < 610000){
    high = $sliderInput + 50000;

  } else if( $high.innerHTML =  $sliderInput < 810000){
    high = $sliderInput + 75000;

  } else if( $high.innerHTML =  $sliderInput < 1010000 ){
    high = $sliderInput + 100000;

  } else if( $high.innerHTML =  $sliderInput < 1610000 ){
    high = $sliderInput + 150000;
  };

  $low.innerHTML = numFormatter( low );
  $high.innerHTML = numFormatter( high );

  let outputNumber = parseFloat(output.innerText.replace(/,/g, ''))
  // moving slider removes style filtering and active states
  $( '.js-style' ).show();
  $( '.js-styleMenu .showhome-tag' ).parent().children().removeClass('active');
  $( '.slider-ranges-inner' ).removeClass('inactive');

  // filter with the price slider
  $( '.js-showhomeCard' ).each( function() {
    let price = $( this ).data( 'price' )
    if( price >= low && price <= high ){
      $( this ).removeClass('hidden order-last');
    } else {
      $( this ).addClass('hidden order-last');
    }
  })

  // filter by build type
  $( '.js-builder' ).each( function() {
    //console.log(outputNumber, $( this ).data( 'build-high' ), $( this ).data( 'build-low' ));
    const inRange = outputNumber <= $( this ).data( 'build-high' ) && outputNumber >= $( this ).data( 'build-low' );

    // if( inRange ){
    //   $( this ).show();
    // } else {
    //   $( this ).hide();
    // }
  })

  // shows the error message if none are in the style
  // $( '.js-style' ).each( function() {
  //   const numberOfBuilders = $( this ).find( '.js-builder:visible').length;
  //   const style = $( this ).data('style');

  //   if( numberOfBuilders == 0) {
  //     $( `#error-${style}` ).show();
  //   } else {
  //     $( `#error-${style}` ).hide();
  //   }
  // })

  // variant - not show error message
  $( '.js-style' ).each( function() {
    const numberOfBuilders = $( this ).find( '.js-builder:visible').length;
    const style = $( this ).data('style');

    if( numberOfBuilders != 0) {
      $( this ).show();
    } else {
      $( this ).hide();
    }
  })

  // push slider value to the data layer - custom conversion tracking in GTM required
  dataLayer.push( { 'event': 'price_input', 'value': $sliderInput } );
  renderShowhomeGrid();
}


// filter by showhome style
$( document ).on( 'click','.js-styleMenu .showhome-tag', function(e) {
  e.preventDefault();

  let $this = $( this );
  let style = $this.data( 'style' );

  $this.parent().children().removeClass('active');
  $this.addClass('active');

  $( '.slider-ranges-inner' ).addClass('inactive');

  $('.js-showhomeCard').removeClass('hidden')
  $('.js-builder').show()
  $('.js-fullWidth').hide()
  $('.error').hide()

  $( '.js-style' ).each( function() {
    if( $( this ).data( 'style' ) == style || style == 'all' ){
      $( this ).show().css( { opacity: 1 } );
    } else {
      $( this ).hide();
    }
  })

  // push style value to the data layer - custom conversion tracking in GTM required
  dataLayer.push( { 'event': 'style_input', 'value': style } );
  renderShowhomeGrid();
})

$( () => { renderShowhomeGrid() })